import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../shared/services/auth.service';
import { HeaderWebComponent } from './shared/components/header/header-web.component';
import { LayoutService } from '../../shared/services/layout.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModaleLogoutComponent } from '../../shared/components/modali/modale-logout/modale-logout.component';

@Component({
	selector: 'app-private-web',
	standalone: true,
	imports: [RouterOutlet, CommonModule, HeaderWebComponent, RouterLink, RouterLinkActive],
	template: `
    <div class="web-shell">
      @if (!layoutService.hideShell()) {
        <app-header-web />
      }

      <div class="main-container" [class.no-shell]="layoutService.hideShell()">
        @if (!layoutService.hideShell()) {
          <aside class="sidebar d-flex flex-column h-100">
            <nav class="nav-menu">
              @if (authService.currentUser?.profilo !== 2) {
                <a routerLink="/web/private/home" routerLinkActive="active" class="nav-item">
                  <i class="bi bi-house"></i>
                  <span>Home</span>
                </a>
                <div class="nav-item group" (click)="toggleGroup()">
                  <i class="bi bi-people"></i>
                  <span>Area Utenti</span>
                  <i class="bi bi-chevron-down ms-auto" [style.transform]="groupOpen() ? 'rotate(180deg)' : 'none'"></i>
                </div>
                @if (groupOpen()) {
                  <a routerLink="/web/private/utenti-interni" routerLinkActive="active" class="nav-sub-item">
                    <span>Interni</span>
                  </a>
                  @if (!authService.currentUser?.cliente?.internalOnly) {
                    <a routerLink="/web/private/utenti-esterni" routerLinkActive="active" class="nav-sub-item">
                      <span>Esterni</span>
                    </a>
                  }
                }

              }
              <a routerLink="/web/private/firma" routerLinkActive="active" class="nav-item">
                <i class="bi bi-pen"></i>
                <span>Firma Pratiche</span>
              </a>
              <a routerLink="/web/private/storico-firmatario" routerLinkActive="active" class="nav-item">
                <i class="bi bi-folder2-open"></i>
                <span>Le Mie Pratiche</span>
              </a>
            </nav>

            <div class="sidebar-footer mt-auto">
              @if (authService.currentUser?.profilo !== 2) {
                <button class="btn-carica" (click)="caricaPratica()">CARICA PRATICA</button>
              }
              <div class="user-profile">
                <div class="user-info">
                  <span class="user-name">{{ authService.currentUser?.nome }} {{ authService.currentUser?.cognome }}</span>
                  <span class="user-email">{{ authService.currentUser?.user }}</span>
                </div>
                <i class="bi bi-box-arrow-right logout-icon" (click)="logout()"></i>
              </div>
            </div>
          </aside>
        }

        <main class="content-wrapper">
          <router-outlet />
        </main>
      </div>
    </div>
  `,
	styles: [],
})
export class PrivateWebComponent implements OnInit {
	authService = inject(AuthService);
	router = inject(Router);
	layoutService = inject(LayoutService);
	modalService = inject(NgbModal);

	groupOpen = signal(false);

	ngOnInit() {
		if (this.authService.currentUser?.profilo === 2 && this.router.url === '/web/private/home') {
			this.router.navigate(['/web/private/firma']);
		}
	}

	toggleGroup() {
		this.groupOpen.update((v) => !v);
	}

	caricaPratica() {
		this.router.navigate(['/web/private/home'], { queryParams: { nuova: true } });
	}

	logout() {
		const modalRef = this.modalService.open(ModaleLogoutComponent, { centered: true });
		modalRef.result.then(
			(result) => {
				if (result) this.authService.logout();
			},
			() => {},
		);
	}
}
